import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { externalCompanyHoldingsApproved } from "store/actions/externalCompanyHoldingsActions";
//#endregion
//#region types
import { ExternalCompanyHoldingsFooterProps } from "models/propTypes/externalCompanyHoldingsPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import ExternalCompanyHoldingsMoreActions from "./moreActions";
import { LocalizationHelperInstance } from "utils/helpers";
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion

const ExternalCompanyHoldingsFooter: React.FC<ExternalCompanyHoldingsFooterProps> = (props) => {
  const { markAsDoneHandler, disableSuccessMessages, submitForm, declarationId, isDisabled } = props;
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const onApproveSuccess = () => {
    if (declarationId) {
      dispatch(externalCompanyHoldingsApproved(declarationId));
    }
    markAsDoneHandler && markAsDoneHandler();
  };

  const onSubmit = () => submitForm();

  return (
    <PageFooter
      allowForReadOnlyUsers
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Confirm),
          onClick: onSubmit,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.AnnualAccount.AnnualReportAcceptSuccessMessage
          ),
          onActionSuccess: onApproveSuccess,
          isDisabled: isDisabled,
        },
      ]}
      moreActions={
        <ExternalCompanyHoldingsMoreActions
          markAsDoneHandler={markAsDoneHandler}
          disableSuccessMessages={disableSuccessMessages}
        />
      }
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default ExternalCompanyHoldingsFooter;
